import { Route, Redirect, RouteProps } from 'react-router-dom'
import { useAuthStateIs } from '@src/stores/auth'

interface PrivateRouteProps extends RouteProps {
  component: any
  componentProps?: any
}

export const PrivateRoute = (props: PrivateRouteProps) => {
  const { component: Component, componentProps: ComponentProps, ...rest } = props
  const loggedIn = useAuthStateIs('LoggedIn')

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (!loggedIn) {
          return (
            <Redirect
              to={{
                pathname: '/signin',
                state: { from: routeProps.location },
              }}
            />
          )
        }

        return <Component {...routeProps} {...ComponentProps} />
      }}
    />
  )
}
